export type ApplicationState = {
  app: string;
};

export const defaultAppState: ApplicationState = {
  app: 'Study App Admin',
};
